export default __webpack_public_path__ + "static/O0047-6ceb87fd002931019b39b64cee7bcfc7.png";